import cx from 'classnames';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';

import { validateEmail } from '@app/libs/validation';
import { modalClose } from '@app/store/modal/actions';

const propTypes = {
  documentId: PropTypes.string,
  senderName: PropTypes.string,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
};

const defaultProps = {
  documentId: '',
  senderName: '',
  onCancel() {},
  onSubmit() {},
};

class SendingToMailModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      validityMessage: '',
    };
    this.handleBlur = this.handleBlur.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleBlur() {
    const { email } = this.state;
    const { message } = validateEmail(email);
    this.setState({ validityMessage: message });
  }

  handleChange({ target: { value } }) {
    const email = value.trim();
    this.setState({ email });
    const { message } = validateEmail(email);
    this.setState({ validityMessage: message });
  }

  handleSubmit(e) {
    e.preventDefault();
    this.handleBlur();

    const { documentId, senderName, onCancel, onSubmit } = this.props;
    const { email } = this.state;

    onSubmit(documentId, senderName, email);
    onCancel();
  }

  render() {
    const { onCancel } = this.props;
    const { email, validityMessage } = this.state;

    return (
      <div className="Container Container--max-xxs">
        <div className="Card Card--pop box-6x align-center">
          <h3 className="space-4x">
            <strong>문서 전달하기</strong>
          </h3>
          <p className="space-6x">
            완료된 문서와 감사 추적 인증서를
            <br />
            첨부하여 전달할 이메일 주소를 입력해 주세요.
          </p>
          <div className={cx('InputSet', 'space-6x', { 'InputSet--invalid': validityMessage })}>
            <input
              className="InputSet__text-input"
              placeholder="이메일 주소"
              type="email"
              value={email}
              onBlur={this.handleBlur}
              onChange={this.handleChange}
            />
            {validityMessage && <p className="InputSet__invalidity-message">{validityMessage}</p>}
          </div>
          <div>
            <button className="Btn" type="button" onClick={onCancel}>
              취소
            </button>
            <button
              className="Btn Btn--primary"
              data-name="submit-button"
              disabled={!(email && !validityMessage)}
              type="submit"
              onClick={this.handleSubmit}
            >
              전달하기
            </button>
          </div>
        </div>
      </div>
    );
  }
}

SendingToMailModal.propTypes = propTypes;
SendingToMailModal.defaultProps = defaultProps;

const mapDispatchToProps = {
  onCancel: modalClose,
};

export default connect(undefined, mapDispatchToProps)(SendingToMailModal);
